{
  "marketing_list": {
    "info": {
      "update_aria_label": "Mettre à jour les informations de la liste",
      "list_suffix": "liste, ",
      "contacts_total": "contacts au total, dernière mise à jour le"
    },
    "form": {
      "name_required": "Veuillez nommer votre liste",
      "category_required": "Veuillez sélectionner une catégorie",
      "list_name_label": "Nom de la liste *",
      "list_name_placeholder": "Nom de la liste",
      "create_header": "Créer une liste marketing",
      "update_header": "Mettre à jour la liste marketing"
    },
    "header": {
      "archived_label": "archivée"
    },
    "actions": {
      "add_contact": "Ajouter un contact",
      "missing_field": "Champ manquant",
      "request_contacts": "Demander des contacts"
    },
    "category": {
      "label": "Catégorie",
      "any": "Tous"
    },
    "contact_request": {
      "description": "Partagez cette URL pour demander à d'autres d'ajouter leurs contacts à cette liste."
    },
    "categories": {
      "client_alert": "Alerte client",
      "country_group": "Groupe de pays",
      "event_invite": "Invitation à un événement",
      "general_marketing": "Marketing général",
      "newsletter": "Bulletin d'information",
      "office_lists": "Listes de bureau",
      "other": "Autre",
      "practice_area": "Domaine de pratique",
      "sector_or_industry": "Secteur ou industrie",
      "subscribers": "Abonnés",
      "webinar_invite": "Invitation au webinaire"
    }
  },
  "excluded_contacts": {
    "alert_message": "Il y a {{count}} contacts dans cette liste avec des règles d'exclusion correspondantes.",
    "show_excluded_link": "Montrez-moi les contacts exclus."
  },
  "filters": {
    "title": "Filtrer",
    "contact_status": {
      "label": "Statut du contact",
      "all": "Tous",
      "bounced": "Rebondis",
      "unengaged": "Non engagés",
      "marketing_excluded": "Exclus du marketing"
    },
    "consent_status": {
      "label": "Statut du consentement",
      "legitimate_interest_tooltip": "Vous pouvez contacter la personne sans consentement explicite en raison d'une relation existante."
    },
    "tags": {
      "label": "Étiquettes",
      "placeholder": "Tapez ou sélectionnez des étiquettes"
    },
    "added_by": {
      "label": "Ajouté par",
      "placeholder": "Tapez le nom ou l'email"
    },
    "missing_field": "Champ manquant",
    "active_filters_aria": "{{count}} filtres sont actifs",
    "apply": "Appliquer",
    "clear_filters": "Effacer les filtres"
  }
}
